import { HARD_MODE_TEXT } from '../../constants/strings'
import { Cell } from '../grid/Cell'
import { BaseModal } from './BaseModal'
type Props = {
  isOpen: boolean
  handleClose: () => void
}

export const HardModal = ({ isOpen, handleClose }: Props) => {
  return (
    <BaseModal title={HARD_MODE_TEXT} isOpen={isOpen} handleClose={handleClose}>
      <div>
        <p className="py-2 text-sm text-gray-500 dark:text-gray-300">
          تمّ تفعيل &nbsp;
          <b>{HARD_MODE_TEXT}</b>
          ،&nbsp;بإمكانك تعطيله متى شئت!
        </p>
        <p className="text-sm text-gray-500 dark:text-gray-300">
          في هذا المستوى يجب أن تستخدم جميع التلميحات التي حصلت عليها في تخمينك
          القادم:
        </p>
        <div className="flex justify-center mb-1 mt-4">
          <Cell value="ا" status="correct" />
          <Cell value="ب" />
          <Cell value="ت" />
          <Cell value="س" />
          <Cell value="م" />
        </div>
        <p className="text-sm text-gray-500 dark:text-gray-300">
          يجب أن تستخدم حرف الألف في المربع الأول.
        </p>

        <div className="flex justify-center mb-1 mt-4">
          <Cell value="ي" />
          <Cell value="ت" />
          <Cell value="ح" />
          <Cell value="د" status="present" />
          <Cell value="ث" />
        </div>
        <p className="text-sm text-gray-500 dark:text-gray-300">
          يجب أن تستخدم حرف الدال في مكان ما.
        </p>

        <div className="flex justify-center mb-1 mt-4">
          <Cell value="ج" />
          <Cell value="س" />
          <Cell value="ي" status="correct" />
          <Cell value="م" status="present" />
          <Cell value="ة" status="correct" />
        </div>
        <p className="text-sm text-gray-500 dark:text-gray-300">
          يجب أن تستخدم حرف الياء في المربع الثالث، وحرف التاء المربوطة في
          المربع الأخير، وحرف الميم في مكان ما.
        </p>
      </div>
    </BaseModal>
  )
}
